import _ from 'lodash';
import roles from 'app/validators/roles';

const CREATED_STATUS = 'CREATED';
const ACTIVE_STATUS = 'ACTIVE';

const STATUS_SUSPENDED_REASONS = ['SUSPENDED_PASSWORD_EXPIRED', 'SUSPENDED_EXCEEDED_MAX_LOGIN_ATTEMPTS', 'SUSPENDED_EXCEEDED_MAX_ANSWERS_ATTEMPTS', 'RESTRICTED_USER'];

function checkIfNotSuspended(model) {
  const statusReason = _.get(model.user.editAccount, 'status.statusReason');
  return STATUS_SUSPENDED_REASONS.indexOf(statusReason) === -1;
}

function canUpdateUserStatus(model) {
  return !checkIfCreated(model);
}

function shouldProvideRetailerId(model) {
  const role = _.get(model, 'session.role');
  return role && roles.ADMIN_ROLES.indexOf(role) !== -1;
}

function isModelUserPrimary(model) {
  const role = _.get(model.user, 'editAccount.userClass');
  return role && roles.PRIMARY_USER_ROLES.indexOf(role) !== -1;
}

function checkIfSelfRegistered(model) {
  const { selfRegistered } = model.user.editAccount;
  return selfRegistered === true;
}

function checkIfNotActive(model) {
  return !checkIfActive(model);
}

function checkIfActive(model) {
  return checkIfStatus(model, ACTIVE_STATUS);
}

function checkIfCreated(model) {
  return checkIfStatus(model, CREATED_STATUS);
}

function checkIfStatus(model, status) {
  return _.get(model.user.editAccount, 'status.status') === status;
}

function canShowRetailerFields(model) {
  return !!model.user.editAccount.retailerId;
}

function canUpdatePrivileges(model) {
  const role = _.get(model.user, 'editAccount.userClass');
  const userId = _.get(model.user, 'editAccount.id');
  return (roles.ADMIN_ROLES.indexOf(role) !== -1 || roles.SECONDARY_USER_ROLES.indexOf(role) !== -1) && userId !== model.session.id;
}

const validators = {
  'user.shouldProvideRetailerId': [shouldProvideRetailerId],
  'user.canResendActivationEmail': [checkIfCreated],
  'user.canCompleteRegistration': [isModelUserPrimary, checkIfNotActive],
  'user.canChangePrimaryUser': [isModelUserPrimary],
  'user.authenticateUser': [isModelUserPrimary, checkIfCreated, checkIfSelfRegistered],
  'user.canShowRetailerFields': [canShowRetailerFields],
  'user.accountInactive': [checkIfNotActive],
  'user.isUserNotSuspended': [checkIfNotSuspended],
  'user.canUpdateUserStatus': [canUpdateUserStatus],
  'user.canUpdatePrivileges': [canUpdatePrivileges],
};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/user/validators/action-validators.js